const STORAGE_KEY = "4uchat.link";

export interface IChatLinkParams {
  ticketId?: string;
  fullScreenChat?: boolean;
  userName?: string;
  initialMessage?: string;
  phoneNumber?: string;
}

const parseBool = (value: string | null): boolean | undefined =>
  value === null ? undefined : value === "true" || value === "1";

export const captureChatLinkParams = () => {
  const params = new URLSearchParams(window.location.search);

  const ticketId = params.get("ticketId") ?? undefined;
  const userName = params.get("userName")?.trim() || undefined;
  const fullScreenChat = parseBool(params.get("fullScreenChat"));
  const initialMessage = params.get("initialMessage")?.trim() || undefined;
  const phoneNumber = params.get("phoneNumber")?.trim() || undefined;

  if (
    !ticketId &&
    !userName &&
    fullScreenChat === undefined &&
    !initialMessage &&
    !phoneNumber
  ) {
    return;
  }

  const link: IChatLinkParams = {
    ticketId,
    userName,
    fullScreenChat,
    initialMessage,
    phoneNumber,
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(link));
  } catch {
    // Sem storage (aba anônima com bloqueio): o chat abre sem os parâmetros.
  }
};

export const getChatLinkParams = (): IChatLinkParams => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as IChatLinkParams) : {};
  } catch {
    return {};
  }
};
